import { useAbility } from '@casl/react';

import { AbilityContext } from '@/setup/casl';

export const useAppAbility = () => useAbility(AbilityContext);
